import { IAboutDetails } from '@/interfaces/IAboutUsData';
import styles from './AboutUsBanner.module.css';
type props = {
    bannerData: IAboutDetails
}
export function AboutUsBanner({ bannerData }: props) {
    return <section className={`${styles.aboutUsHeader} new_abt_banner`}>
        <img src="/assets/images/aboutBanner.png" className={`imgResponsive ${styles.aboutUsBanner}`} width="100" height="100" alt="about us banner" />
        <div className="container">
            <h2 className={`sectionHeading ${styles.sectionHeading} textfff ${styles.textShadow}`}><span className={styles.textOverlay}>About US </span></h2>
        </div>
    </section>
}